import _extends from "@babel/runtime-corejs3/helpers/extends";
import React from "react";
import cx from "classnames";
import { IconButton } from "../../../IconButton/IconButton";
import { getKeyPressHandler } from "../../../../accessibility/getKeyPressHandler";
import { messages } from "../GenericSelectControl.messages";
export var GenericSelectControlClearIndicator = function (_ref) {
  var className = _ref.className,
    genericSelectStyles = _ref.selectProps.genericSelectStyles,
    innerProps = _ref.innerProps;
  return React.createElement(IconButton, _extends({}, innerProps, {
    className: cx(className, genericSelectStyles.selectIcon, genericSelectStyles.cancel),
    icon: "gw-cancel",
    "aria-hidden": "false",
    ariaLabel: messages.clearButton,
    onKeyDown: getKeyPressHandler(innerProps.onMouseDown)
  }));
};
GenericSelectControlClearIndicator.__docgenInfo = {
  description: "",
  methods: [],
  displayName: "GenericSelectControlClearIndicator"
}, GenericSelectControlClearIndicator.__docgenInfo = {
  componentName: "GenericSelectControlClearIndicator",
  packageName: "@jutro/components",
  description: "",
  displayName: "GenericSelectControlClearIndicator",
  methods: [],
  actualName: "GenericSelectControlClearIndicator"
};